import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { Colors, ColorsType } from 'works/legacy/lib/style-helper';

type Props = {
  size?: 'sm' | 'md' | 'lg';
  weight?: 'light' | 'medium' | 'bold';
  color?: ColorsType;
  center?: boolean;
  className?: string;
};

export function Paragraph({
  size = 'md',
  weight = 'light',
  color = 'textDefault',
  center = false,
  className,
  children,
}: PropsWithChildren<Props>) {
  const colorHash = Colors[color];

  return (
    <>
      <p
        className={clsx(
          className,
          `wk-paragraph wk-paragraph-size--${size} wk-paragraph-weight--${weight}`,
          {
            'wk-paragraph--center': center,
          }
        )}
      >
        {children}
      </p>
      <style jsx>{`
        .wk-paragraph {
          color: ${colorHash};
          margin: 0;
        }

        .wk-paragraph--center {
          text-align: center;
        }

        .wk-paragraph-weight--light {
          font-weight: 300;
        }
        .wk-paragraph-weight--medium {
          font-weight: 500;
        }
        .wk-paragraph-weight--bold {
          font-weight: 600;
        }

        .wk-paragraph-size--sm {
          font-size: 12px;
        }
        .wk-paragraph-size--md {
          font-size: 14px;
        }
        .wk-paragraph-size--lg {
          font-size: 16px;
        }

        p.wk-paragraph + p.wk-paragraph-size--sm {
          margin-top: 20px;
        }
        p.wk-paragraph + p.wk-paragraph-size--md {
          margin-top: 24px;
        }
        p.wk-paragraph + p.wk-paragraph-size--lg {
          margin-top: 28px;
        }

        p.wk-paragraph-size--sm {
          line-height: 20px;
        }
        p.wk-paragraph-size--md {
          line-height: 24px;
        }
        p.wk-paragraph-size--lg {
          line-height: 28px;
        }
      `}</style>
    </>
  );
}
